module.exports = __webpack_public_path__ + "img/complete.d18ea917.png";